import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { createWorker } from 'tesseract.js';
import { HighlightPipe } from '../../pipes/highlight.pipe';
import { DropzoneComponent } from '../dropzone/dropzone.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-image-to-text1',
  standalone:true,
  imports: [FormsModule,CommonModule,DropzoneComponent],
  templateUrl: './image-to-text.component.html',
  styleUrls: ['./image-to-text.component.scss']
})
export class ImageToText1Component {
  extractedText: string = '';
  languageSelect: string = 'eng';
  loading: boolean = false;
  searchText = '';
  searchResult = '';

  onFileSelected(event: any): void {
    const file = event
    if (file) {
      const reader = new FileReader();

      reader.onload = () => {
        const imageData = reader.result as string;
        this.performOCR(imageData);
      };

      reader.readAsDataURL(file);
    }
  }
  imageData: string = '';
  onFileChoose(event: any): void {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();

      reader.onload = () => {
        const imageData = reader.result as string;
        this.performOCR(imageData);
      };

      reader.readAsDataURL(file);
    }
  }
lanChange(){
  if(this.extractedText){
    this.performOCR(this.imageData);
  }

}
reset(){
  this.extractedText='';
  this.imageData='';
  this.searchText='';
  this.searchResult='';
  const fileInput = document.getElementById('fileInput') as HTMLInputElement;
  fileInput.value = '';
}

  async performOCR(imageData: string): Promise<void> {
    this.imageData = imageData;
    this.loading = true;
    try {
      // const worker = await createWorker('eng');
      const worker = await createWorker(this.languageSelect);
      const { data: { text } } = await worker.recognize(imageData);
      this.extractedText = this.removeAngleBrackets(text);
      await worker.terminate();
    } catch (error) {
      console.error('OCR Error:', error);
    } finally {
      this.loading = false;
    }
  }

  search() {
    if (this.extractedText.toUpperCase().includes(this.searchText.toUpperCase())) {
      this.searchResult = 'Text "' + this.searchText + '"' + ' exists. Occurrences: ' + this.countNumberOfOccurrences();
    } else {
      this.searchResult = "Not exist";
    }
  }

  countNumberOfOccurrences() {
    const regex = new RegExp(this.searchText.toUpperCase(), "g");
    const count = (this.extractedText.toUpperCase().match(regex) || []).length;
    return count;
  }

  removeAngleBrackets(text: string): string {
    return text.replace(/[<>]/g, ' ');
  }
}